<section class="app-failed-add-ons">
  @if (failedAddons$ | async; as failedAddons) {
    @if (failedAddons.length > 0) {
      <se-fe-alert seFeDataType="critical" [seFeDismissible]="false">
        Some items were not added to your cart
        <p>
          An error occurred and we were unable to add the following items to
          your cart. Try again to add them to your cart. Otherwise, you can
          proceed to checkout.
        </p>
        <ul>
          @for (addOn of failedAddons; track addOn.itemVariationId) {
            <li>{{ addOn.name }}</li>
          }
        </ul>
      </se-fe-alert>
    }
  }
</section>
<se-fe-footer class="se-fe-footer">
  @if (failedAddons$ | async; as failedAddons) {
    @if (failedAddons.length > 0) {
      <se-fe-button
        [seFeDataIsLoading]="(loading$ | async) ?? false"
        seFeDataEmphasis="medium"
        [seFeDataFullWidth]="(breakpointUtils.smallScreen$ | async) ?? false"
        (click)="retry()">
        Add Items to Cart
      </se-fe-button>
    }
  }
  <se-fe-button
    [seFeDataIsDisabled]="(loading$ | async) ?? false"
    seFeDataEmphasis="high"
    [seFeDataFullWidth]="(breakpointUtils.smallScreen$ | async) ?? false"
    (click)="continue()">
    Continue
  </se-fe-button>
</se-fe-footer>
